import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CaseDetailStickyService {
  private downloadPDFSource = new Subject<void>();
  private openSimilarPricingSource = new Subject<void>();

  downloadPDF$ = this.downloadPDFSource.asObservable();
  openSimilarPricing$ = this.openSimilarPricingSource.asObservable();

  constructor() { }

  triggerDownloadPDF(): void {
    this.downloadPDFSource.next();
  }

  triggerOpenSimilarPricing(): void {
    this.openSimilarPricingSource.next();
  }
}
